export default __webpack_public_path__ + "static/media/Masque-ruban-03.64ddc6ae.webp";